import { T } from "../tokens";
import { passwordStrength } from "../lib/password-strength";

// The 4-segment password strength meter — colour walks weak→strong. Renders
// nothing for an empty password. Shared by signup (Login) and reset-password.
export function PasswordStrengthMeter({ password }: { password: string }) {
  const { score, level, label } = passwordStrength(password);
  if (!password) return null;
  const color = level === "strong" ? T.ok : level === "good" ? T.teal : level === "fair" ? T.warn : T.err;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
      <div style={{ display: "flex", gap: "4px" }}>
        {[0, 1, 2, 3].map((i) => (
          <div key={i} style={{ flex: 1, height: "3px", borderRadius: "2px",
            background: i < score ? color : T.b1, transition: "background 0.15s ease" }}/>
        ))}
      </div>
      <span style={{ fontFamily: T.body, fontSize: "11px", color }}>{label}</span>
    </div>
  );
}
